var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "row" }, [
    _c("div", { staticClass: "col-xs-12" }, [
      _c("ul", { staticClass: "list-inline" }, [
        _c("li", [_vm._v("Last update: " + _vm._s(_vm.LastUpdate))]),
        _vm._v(" "),
        _c("li", [_vm._v("© 2019 Chevron Corporation")]),
        _vm._v(" "),
        _c("li", [_vm._v("Company Confidential")]),
        _vm._v(" "),
        _vm._m(0),
      ]),
      _vm._v(" "),
      _vm._m(1),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _vm._v("OpCo : "),
      _c("a", { attrs: { href: "https://thailandupstream.chevron.com/" } }, [
        _vm._v("Chevron Thailand"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "list-inline" }, [
      _c("li", [
        _vm._v("Content contact: "),
        _c("a", { attrs: { href: "#" } }, [_vm._v("Chevron Template Admin")]),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("Technical contact: "),
        _c("a", { attrs: { href: "mailto:itsupport@chevron.com" } }, [
          _vm._v("Global IT Service Desk"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }